import React, { useMemo } from 'react';
import { PageLayout, PanelTabs } from 'common/components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useLocation, useHistory, useRouteMatch } from 'react-router-dom';
import queryString from 'query-string';
import DashboardsPage from '../DashboardsPage';

const DashboardsWrapperPage = ({ addons, profile }) => {
  const location = useLocation();
  const history = useHistory();
  const match = useRouteMatch();

  const isClientInterface = !window.location.href.includes('backoffice');

  const activeTabSlug = useMemo(() => queryString.parse(location.search).tab || 'my', [location.search]);

  return (
    <PageLayout captionSlug="boDashboards">
      {addons.includes('managerSystem') && profile.isManager && profile.perms.managerViewDashboard ? (
        <PanelTabs activeTabSlug={activeTabSlug} location={location} history={history}>
          <DashboardsPage
            isClientInterface={isClientInterface}
            textId="justMyClients"
            slug="my"
            match={match}
            sampleType={isClientInterface ? 'partner' : 'manager'}
            partnerId={profile.id}
          />
          {profile.perms.viewDashboards && !isClientInterface && (
            <DashboardsPage
              isClientInterface={isClientInterface}
              textId="justAllClients"
              slug="all"
              match={match}
              sampleType="full"
              viewMode="allUsers"
              partnerId={profile.id}
            />
          )}
        </PanelTabs>
      ) : (
        <DashboardsPage
          isClientInterface={isClientInterface}
          textId={isClientInterface ? 'justMyClients' : 'justAllClients'}
          slug={isClientInterface ? 'my' : 'all'}
          match={match}
          sampleType={!isClientInterface ? 'full' : 'partner'}
          viewMode={!isClientInterface && 'allUsers'}
          partnerId={profile.id}
        />
      )}
    </PageLayout>
  );
};

DashboardsWrapperPage.propTypes = {
  profile: PropTypes.object.isRequired,
  addons: PropTypes.array.isRequired,
};

export default connect(state => ({
  currentInterfaceSlug: state.user.currentInterface,
  addons: state.interfaceConfig.addons,
  profile: state.user.profile,
}))(DashboardsWrapperPage);

export { DashboardsWrapperPage };
